class FormFranchiseMessage extends BaseForm {
	constructor(options) {
		super(options);

		//set default variables
		this.fields = [
			{name: 'name'},
			{name: 'email', type: 'email'},
			{name: 'consent'},
			{name: 'message'}
		];
	}

	init(){
		super.init();

		this.formOptions.recaptcha =  {
			id: 'recaptcha-franchise-2',
			options: {
				'sitekey' : SETTINGS.RECAPTCHA,
				'theme'    : 'light'
			}
		};

		this.initForm();
	}

	doTracking(){
		Me.track.event("Franchise Form", "Submit", "Franchise message");
	}
}
